export default __webpack_public_path__ + "static/media/errorbackground.29d362b8.png";